import React, { useEffect, useState } from "react";
import API from "../Services/Receipt";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
const ReceiptSetting = () => {
  const [receipt, setReceipt] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [type, setType] = useState("");
  const [id, setId] = useState([])
  const perPage = 10;
  const [status, setStatus] = useState("");
  const [createdDate, setCreatedDate] = useState("")
  const [logo, setLogo] = useState("")
  const [logoPreview, setLogoPreview] = useState(null)


  useEffect(() => {
    bindReceipt();
  }, [currentPage])


  const bindReceipt = async () => {
    try {
      const payload = {
        pageNumber: currentPage,
        limit: perPage,
      };
      const response = await API.GetReceipt(payload);
      // console.log("response data....",response?.data?.totalCount)
      setReceipt(response.data.data);
      setTotalRecords(response.data.totalCount)
    } catch (error) {
      toast.dismiss();
      if (!error.response) {
        toast.error("Network error! Please check your internet connection");
      } else if (error.response.status === 403) {
        window.location.replace("/Login")
        toast.error("Network error! Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const totalPages = Math.ceil(totalRecords / perPage);
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      // setCurrentPage(page);
      // bindReceipt();
    }
  };


  const handleStatusToggle = async (id, currentStatus) => {
    const updatedStatus = !currentStatus;
    try {
      const response = await API.UpdateStatus(id, updatedStatus);
      if (response.status === 200) {
        setReceipt((prevLocation) =>
          prevLocation.map((item) =>
            item.id === id ? { ...item, is_active: updatedStatus } : item
          )
        );
        toast.success(response.data.message);
      } else {
        toast.error("Error updating status:", response);
        toast.error("Failed to update the status. Please try again.");
      }
    } catch (error) {
      if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      console.log("Error in status toggle:", error);
      toast.error("Failed to update the status. Please try again.");
    }
  };


  const handleGetData = async (id) => {
    try {
      setId(id);
      const response = await API.GetReceipt({ id: id });
      const fetchedData = response?.data?.data?.[0];
      // console.log("fetch data....", fetchedData)
      if (fetchedData) {
        setInputValue(fetchedData.value);
        setType(fetchedData.type)
        setStatus(fetchedData?.is_active)
        setCreatedDate(fetchedData?.createdAt)
        setLogoPreview(fetchedData?.logo)
      } else {
        toast.error("Failed to fetch receipt details.");
      }
    } catch (error) {
      if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      console.error("Error fetching data:", error);
    }
  };

  const handleUpdate = async () => {

    if (!inputValue) {
      toast.error("Please Enter  required fields.");
      return;
    }
    const payload = {
      type: type,
      value: inputValue
    };
    try {
      const response = await API.updateReceipt(id, payload);
      if (response.status === 200) {
        toast.success(response.data.message);
        bindReceipt();
        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      if (error.response.status === 403) {
        window.location.replace("/Login");
      }
      if (error.response) {
        if (error.response.status === 400) {
          toast.error(error.response.data.message || "Bad Request: Please check your input.");
        } else {
          toast.error(`Error ${error.response.status}: ${error.response.data.message}`);
        }
      } else if (error.request) {
        toast.error("No response from server. Please try again later.");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    }
  };



  const handleGetLogo = (logo) => {
    // console.log("logo...", logo)
    setLogo(logo);
  }

  return (
    <div>
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Added Receipt Setting</h4>
          </div>
           <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>SrNo</th>
                  <th>Action</th>
                  <th>Type</th>
                  <th>Value</th>
                  <th>Status</th>

                  <th>Created-Date</th>
                  <th>Logo</th>
                </tr>
              </thead>
              <tbody>
                {receipt.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    {/* <td>
                    <button className="btn btn-success btn-sm" onClick={() => handleGetData(item.id)}
                      data-bs-toggle="modal" data-bs-target="#myModal"
                    >Edit</button>{' '}
                    <button
                      className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                      onClick={() => handleStatusToggle(item.id, item.is_active)}
                    >
                      {item.is_active ? "Deactivate" : "Activate"}
                    </button>
                  </td> */}
                    <td>
                      <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                        <ul className="navbar-nav navbar-nav-right">
                          <li className="nav-item nav-profile1">
                            <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                              <div className="nav-profile-text1">
                                <p className="mb-1 text-black">
                                </p>
                              </div>
                            </span>
                            <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                            <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                              <a className="dropdown-item">
                                <button onClick={() => handleGetData(item.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                  View
                                </button>
                              </a>
                              <div className="dropdown-divider"></div>
                              <a className="dropdown-item">
                                {/* <button className="btn btn-primary btn-sm" onClick={() => handleGetData(item.id)}>Edit</button>{' '} */}
                                <button onClick={() => handleGetData(item.id)}
                                  className="btn btn-primary btn-sm" type="button"
                                  data-bs-toggle="modal" data-bs-target="#myModal"
                                >
                                  Edit
                                </button>
                              </a>
                              <div className="dropdown-divider"></div>
                              <a className="dropdown-item">
                                <button
                                  className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                  onClick={() => handleStatusToggle(item.id, item.is_active)}>
                                  {item.is_active ? "De-Activated" : "Activate"}
                                </button>
                              </a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </td>
                    <td>
                      {item.type}
                    </td>
                    <td>
                      {item.value}
                    </td>
                    {/* <td><img src={item.logo} alt="Logo" style={{ "width": "100px", "height": "100px" }} />
                   */}
                    <td>{item?.is_active ? "Active" : "De-Activated"}</td>

                    {/* </td> */}
                    {/* <td>Image</td> */}
                    <td>
                      {moment(item.createdAt).format("DD-MM-YYYY")}
                    </td>    <td>
                      {/* <button onClick={() => handleGetLogo(item.logo)}
                        className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModallogo">
                        View
                      </button> */}

                      {item.logo && item.logo.trim() !== "" ? (
                        <button
                          onClick={() => handleGetLogo(item.logo)}
                           className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModallogo"
                        >
                          View
                        </button>
                      ) : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <nav aria-label="Page navigation example">
              <ul className="pagination justify-content-center  mt-3">
                {/* Previous Button */}
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                </li>
                {Array.from({ length: Math.min(totalPages, 5) }, (_, index) => {
                  const pageStart = Math.max(currentPage - 2, 1);
                  const pageEnd = Math.min(pageStart + 4, totalPages);
                  const page = pageStart + index;
                  if (page > pageEnd) return null;
                  return (
                    <li
                      key={page}
                      className={`page-item ${currentPage === page ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    </li>
                  );
                })}

                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
            </div>
          </div>
        </div>
      </div>
      {/* <ToastContainer /> */}
      <section>
        <div className="modal" id="myModal" data-bs-backdrop="static">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Update Receipt</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <input type="text" className="form-control" value={inputValue} onChange={(e) => setInputValue(e.target.value)}></input>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary" onClick={handleUpdate}>Update</button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
          <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
            <div className="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Receipt Details</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-bordered text-center">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>Value</th>
                              <th>Status</th>
                              <th>Created Date</th>
                              <th>Logo</th>
                            </tr>
                            <tr>
                              <td>{type}</td>
                              <td>{inputValue}</td>
                              <td>{status ? "Active" : "De-Activated"}</td>
                              <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                              <td>
                                <img src={logoPreview} alt="Logo" width="50" height="50" />
                              </td>
                            </tr>
                          </thead>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="modal" id="myModallogo">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Logo</h4>
                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="row my-3" style={{ justifyContent: "center", alignItems: "center" }}>
                  <img src={logo} alt="Logo" style={{ "width": "100px", "height": "100px" }} />
                </div>
                <div className="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReceiptSetting;
